// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__371Dc","left":"styles_left__3V6qI","desktopActions":"styles_desktopActions__3N2rK","title":"styles_title__doLAM"};